import React from "react";
import "../../css/CreatingTestCase.css";

export default function CreatingTestCase() {
  return (
    <>

      <h2 className="ct-title">
        Unlock Efficiency with AI-Powered Test Case Generation
      </h2>

      <div className="ct-grid">

        {/* CARD 1 */}
        <div className="ct-item">
          <div className="ct-border"></div>

          <div className="ct-card">
            <img
              src="/assets/frothai/bye.png"
              alt="bye"
              className="ct-icon"
            />
            <p>
              Automate the boring work, concentrate on strategy, release your team from manual test case creation and thereby be able to invest more time in high-impact testing strategies with FrothAI.
            </p>
          </div>
        </div>

        {/* CARD 2 */}
        <div className="ct-item">
          <div className="ct-border"></div>

          <div className="ct-card">
            <img
              src="/assets/frothai/ai.png"
              alt="ai"
              className="ct-icon"
            />
            <p>
              Remove errors caused by humans and improve software reliability as AI-driven testing lessens risks and thus, guarantees complete coverage.
            </p>
          </div>
        </div>

        {/* CARD 3 */}
        <div className="ct-item">
          <div className="ct-border"></div>

          <div className="ct-card">
            <img
              src="/assets/frothai/speed.png"
              alt="speed"
              className="ct-icon"
            />
            <p>
              In fact, to test efficiently, you should be able to rapidly create test cases thus, you can reduce turnaround time and accelerate software delivery.
            </p>
          </div>
        </div>

        {/* CARD 4 */}
        <div className="ct-item">
          <div className="ct-border"></div>

          <div className="ct-card">
            <img
              src="/assets/frothai/output.png"
              alt="output"
              className="ct-icon"
            />
            <p>
              Increase productivity, get the most out of your time, spend less time writing tests and more time focusing on execution, optimization, and delivering high-quality results faster.
            </p>
          </div>
        </div>

      </div>

    </>
  );
}